import { useRef } from 'react';
import { DayProps, useDayRender } from 'react-day-picker';

import { CalendarThemeColor } from './Calendar.theme';
import * as Styled from './CalendarDay.styles';

type CalendarDayProps = DayProps & { themeColor: CalendarThemeColor };

const CalendarDay = ({ date, displayMonth, themeColor }: CalendarDayProps) => {
  const ref = useRef(null);
  const dayRender = useDayRender(date, displayMonth, ref);

  return (
    <Styled.Container
      ref={ref}
      {...dayRender.buttonProps}
      $activeModifiers={dayRender.activeModifiers}
      $themeColor={themeColor}>
      {dayRender.divProps.children}
    </Styled.Container>
  );
};

export default CalendarDay;
